import React from 'react';
import PropTypes from 'prop-types';
import JsBarcode from 'jsbarcode';

class Barcode extends React.Component {
  constructor(props) {
    super(props);
    this.svgRef = React.createRef();
  }

  componentDidMount() {
    this.renderBarcode();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value || prevProps.options !== this.props.options) this.renderBarcode();
  }

  renderBarcode() {
    const {current: svg} = this.svgRef;
    if (!svg) return;
    const {value, options} = this.props;
    if (value) {
      JsBarcode(svg, value, options);
    } else {
      svg.innerHTML = '';
    }
  }

  render() {
    return <svg className="barcode" ref={this.svgRef}/>;
  }
}

Barcode.propTypes = {
  value: PropTypes.string,
  options: PropTypes.object,
};

export default Barcode;


// WEBPACK FOOTER //
// ./src/common/Barcode.js